// Signed in to Keycloak but not linked to an Xpedition2 account (GET /me → 404, code 1040): every API call
// would fail, so say so plainly - with the reason the API gives - instead of showing empty pages.
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useMe } from './me';
import { useAccount } from './useAccount';
import styles from './LinkedAccountGate.module.css';

export function LinkedAccountGate({ children }: { children: ReactNode }) {
  const me = useMe();
  // While /me loads, show the app: almost everyone is linked, and the avatar fills in when it arrives.
  if (me.error?.notLinked) return <NotLinked reason={me.error.details[0]} />;
  return <>{children}</>;
}

function NotLinked({ reason }: { reason?: string }) {
  const { t } = useTranslation();
  const account = useAccount();
  return (
    <main className={styles.page}>
      <section className={styles.card} role="alert">
        <h1>{t('auth.notLinked.title')}</h1>
        <p>{t('auth.notLinked.body', { email: account.email ?? account.name })}</p>
        {reason && (
          <p className={styles.reason}>
            <span className="label">{t('auth.notLinked.reason')}</span> {reason}
          </p>
        )}
        <p>{t('auth.notLinked.help')}</p>
        <button type="button" className={styles.button} onClick={account.signOut}>
          {t('nav.signOut')}
        </button>
      </section>
    </main>
  );
}
